var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resign-container"},[_c('img',{staticClass:"resign-img",attrs:{"src":_vm.imgUrl}}),_vm._v(" "),_c('div',{staticClass:"resign-text"},[_vm._v(_vm._s(_vm.resignText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d652aa8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/resign.vue
// module id = null
// module chunks = 